import {
  faArrowDown,
  faArrowUp,
  faMinus,
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';

import { iff } from '»utils/code';
import { getDecimalDigits } from '»utils/number';

import {
  DataValue,
  FontAwesomeIconStyled,
  VariationPctgContainer,
} from './TrlVariationLabel.styles';

export const TrlVariationLabel = ({ variationPctg, parent, decimalDigits }) => (
  <VariationPctgContainer parent={parent}>
    <DataValue value={variationPctg} parent={parent}>
      {variationPctg === null || variationPctg === undefined ? null : (
        <FormattedNumber
          value={variationPctg}
          maximumFractionDigits={getDecimalDigits(decimalDigits)}
          minimumFractionDigits={getDecimalDigits(decimalDigits)}
        />
      )}
    </DataValue>
    {variationPctg > 0 ? (
      <FontAwesomeIconStyled
        value={variationPctg}
        icon={faArrowUp}
        parent={parent}
      />
    ) : (
      iff(
        variationPctg < 0,
        <FontAwesomeIconStyled
          value={variationPctg}
          icon={faArrowDown}
          parent={parent}
        />,
        <FontAwesomeIconStyled
          value={variationPctg}
          icon={faMinus}
          parent={parent}
        />,
      )
    )}
  </VariationPctgContainer>
);

TrlVariationLabel.propTypes = {
  variationPctg: PropTypes.number.isRequired,
  parent: PropTypes.oneOf([
    'card',
    'cardMobileList',
    'cardMobileDetails',
    'dashboard',
    'dashboardSmall',
  ]),
  decimalDigits: PropTypes.number,
};
